import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { AccountFunctionsService } from '../account-functions.service';

@Component({
  selector: 'add-account-function',
  templateUrl: './add-account-function.component.html',
  styleUrls: ['./add-account-function.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddAccountFunctionComponent implements OnInit {
  createFolderForm: UntypedFormGroup;

  /**
   * Constructor
   *
   * @param {MatDialogRef} matDialogRef
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<AddAccountFunctionComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _accountFunctionsService: AccountFunctionsService,
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.createFolderForm = this._formBuilder.group({
      method_name: ['', [Validators.required]],
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Save and close
   */
  saveAndClose(): void {
    // Save the message as a draft
    this.saveAsDraft();

    // Close the dialog
    this.matDialogRef.close();
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Save the message as a draft
   */
  saveAsDraft(): void {}

  /**
   * Send the message
   */
  save(): void {
    let accountFunction = this.createFolderForm.value;

    this._accountFunctionsService.saveAccountFunction(accountFunction).subscribe((af) => {
      this.matDialogRef.close();
    });
  }
}
